import { render, staticRenderFns } from "./PosInvoicesTaxRefundEdit.vue?vue&type=template&id=513e68cb&scoped=true&"
import script from "./PosInvoicesTaxRefundEdit.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxRefundEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e68cb",
  null
  
)

export default component.exports